module.exports = __webpack_public_path__ + "img/VRfprSDGs-650x340.2b21a4a1.png";